
import React, { useState, useEffect, useContext } from "react";


import Footer from "../components/dashboard/footer";
import Header from "../components/dashboard/header";
// import Sidebar from "../components/dashboard/sidebar";
import SideMenu from "./student/SideMenu";
import { useNavigate, Link, useLocation } from "react-router-dom";
import axios from 'axios';
import tmdbApi from "../api/tmdbApi";
import moment from "moment";

import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../context/contentContext";
import { ToastContainer, toast } from 'react-toastify';
import TableLoader from "../components/tableLoader";
import Loader from "../components/loader";
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import parse from "react-html-parser";
import SessionPopup from "../pages/SessionPopup";
// import { Tooltip } from "reactstrap";
import Tooltip from '@mui/material/Tooltip'

let { lambda, appname } = window.app

const Feedbacks = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { search } = state || {};

    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [tableErrMsg, setTableErrMsg] = useState(false);
    const [toastMessage, setToastMessage] = useState(""); // State for dynamic message

    const [deleteShow, setDeleteShow] = useState(false);
    const [deleteUserId, setDeleteUserId] = useState(false);
    const [deleteSuccess, setDeleteSuccess] = useState(false);

    let id = localStorage.getItem("userId");

    const [flag, setFlag] = useState(false);
    const [usersearch, setUserSearch] = useState("");
const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
const [showSuccessAlert, setShowSuccessAlert] = useState(false);
const [successMessage, setSuccessMessage] = useState("");
const [showErrorAlert, setShowErrorAlert] = useState(false);
const [errorMessage, setErrorMessage] = useState("");
const [activeModuleId, setActiveModuleId] = useState("");
const [activeCaseId, setActiveCaseId] = useState("");


    // const [isLoading, setIsLoading] = useState(false); 
    const { searchedFlag, setSearchedFlag, isLoading, setIsLoading, userData, setUserData, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, currentPage, setcurrentPage, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, GetTimeActivity, isRestricted } = useContext(contentContext)
    const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu === "Users")
    const subValDashboard = validateObj && validateObj[0] && validateObj[0].dashboard
    // console.log('validate obj', validateObj)

    const prevRoute = usePrevious(route)
    useEffect(() => {
        if (prevRoute !== undefined && prevRoute != route) {
            setCurrentPage(1)
            setRowsPerPage(15)
            setSearchedFlag(false);
            setUserSearch("")
        }
    }, [prevRoute]);
    //  console.log('prevRoute--->',prevRoute)
    //  console.log('currentRoute--->',route)
    useEffect(() => {
        if (toastMessage) {
            toast.success(toastMessage, {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            // Clear the message after showing to prevent re-triggering
            setToastMessage("");
        }
    }, [toastMessage]);
    const keyForRerender = `${rowsPerPage}_${data?.length}`;
    const columns = [
              {
            name: 'Case',
            selector: row => parse(row?.casename) ?? "",
            sortable: true,
        },
     
        {
            name: 'Module Name',
            selector: row => row?.modulename ?? "",
            sortable: true,
        },
  
        {
            name: 'Feedbacks',
            sortable: true,
             selector: row => row?.feedbackCount ?? "",
          
        },

      
        {
            name:

                'Actions'
            ,
            cell: (props) =>
                //   {

                <div className="d-flex">

                    {/* <a onClick={(e) => handleViewUser(e, props.caseid)}
                        className='text-success action-button'><i
                            className="mdi mdi-eye font-size-18"></i>  </a> */}

                    <a onClick={(e) => handleEditFeedback(e, props)}
                        // className='text-danger action-button'
                        className={`text-danger action-button ${isRestricted ? "pe-none opacity-50" : ""}`}><i
                            className="mdi mdi-pencil font-size-18"></i> </a>

                    <a onClick={(e) => confirmFeedbackDeletion(e, props)}
                        // className='text-danger action-button'
                        className={`text-danger action-button ${isRestricted ? "pe-none opacity-50" : ""}`}><i
                            className="mdi mdi-delete font-size-18"></i> </a>

                </div>
            //  }
            ,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const dateFormat = (created) => {
       
        const dateObj = new Date(created);

        // Extract date parts in IST
        const day = dateObj.toLocaleString('en-GB', { day: '2-digit', timeZone: 'Asia/Kolkata' });
        const month = dateObj.toLocaleString('en-GB', { month: '2-digit', timeZone: 'Asia/Kolkata' });
        const year = dateObj.toLocaleString('en-GB', { year: 'numeric', timeZone: 'Asia/Kolkata' });

        // Extract time parts in IST with AM/PM
        const time = dateObj.toLocaleString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
            timeZone: 'Asia/Kolkata'
        });

        // Combine date and time
        const formattedDateTime = `${day}-${month}-${year} ${time}`;
        return formattedDateTime.toUpperCase();
    }


    const handlePageChange = (page) => {
        GetTimeActivity()
        setCurrentPage(page);
    };

    const handlePerRowsChange = (newPerPage) => {
        GetTimeActivity()
        setRowsPerPage(newPerPage);
    };
const confirmFeedbackDeletion = (e,param) => {

    console.log('parrrrrrrrrrrrrrrrrrrrram',param)
    // setDeleteUserId(userId);
    setActiveModuleId(param.moduleid)
    setActiveCaseId(param.caseid)
    setShowDeleteConfirmation(true);
};
const handleDeleteCancelled = () => {
    setShowDeleteConfirmation(false);
    setDeleteUserId(null);
    setActiveModuleId("")
    setActiveCaseId("")
};
    useEffect(() => {
        setRoute("user")
        // setActiveMenuId(200003)
        setData([])
        // userActivity();
        if (!localStorage.getItem("token")) {
            navigate("/");
        }
    }, []);




    useEffect(() => {
        if (searchedFlag) {
            handleSearch();
        } else {
            GetFeedbacksApi();
        }

    }, [searchedFlag]);




    const GetFeedbacksApi = (e) => {
        setIsLoading(true)
        const userId = localStorage.getItem("userId")
        const token = localStorage.getItem("token")
        axios({
            method: 'POST',
            // url: lambda + '/getFeedbackSummary?appname=' + appname + '&userid=' + userId + '&token=' + token,
            url: lambda + '/getFeedbackSummary?appname=' + appname,
        })
            .then(function (response) {
                if (response?.data?.result === "Invalid token or Expired") {
                    setIsLoading(false)
                    setShowSessionPopupup(true)
                    //                 localStorage.clear();
                    //    navigate("/")
                } else {
                    const data = response?.data?.result?.filter(
                        item => item.feedbackCount !== 0
                    );

                    setData(data);
                    // global.exportExcelData = response?.data?.result?.questionData



                    setIsLoading(false);
                    setUserSearch("");
                    setSearchedFlag(false);
                }
            }).catch((err) => {
                console.log('error', err);
                setTableErrMsg(true)
                setIsLoading(false);
            });
    }





    const handleSearch = (e, flagggg) => {
        if(usersearch.trim().length === 0 || usersearch === ""){
             toast.error("Search field cannot be empty.");

            return;
        }

        
        setIsLoading(true)
        const token = localStorage.getItem("token")
        const userId = localStorage.getItem("userId")
        axios({
            method: 'POST',
            url: lambda + '/getFeedback?appname=' + appname + "&type=admin&search=" + usersearch,
        })
            .then(function (response) {
                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                    
                } else {

                   const data = response?.data?.result?.filter(
                        item => item.feedbackCount !== 0
                    );

                    setData(data);


                    setIsLoading(false)
                }
            }).catch((err) => {
                console.log('error', err);
                setTableErrMsg(true)
                setIsLoading(false);
            });
        // }
    }

    const handleChange = (e) => {
        if (e.target.value === "") {
            //   GetFeedbacksApi();
            setFlag(false)
        }
        setUserSearch(e.target.value)
    }



    const handleKeypress = (e) => {
        //it triggers by pressing the enter key
        GetTimeActivity()
        if ((e.key === "Enter")) {
            setTimeout(function () {
                handleSearch();
            }, 1000);
        }
    };
    const handleAddUser = (e) => {
        navigate("/addcase");
    }

    const handleEditFeedback = (e, param) => {
        console.log('param', param)
        navigate("/casefeedback/" + param.moduleid+"/"+param.caseid);
    }

    const handleDeleteFeedback = (e, param) => {
        setDeleteUserId(param)
        setDeleteShow(true)
    }

    const onDeleteCancel = (e) => {
        setDeleteShow(false)
        setDeleteUserId(null)

    }

    const onDeletePopupClose = (e) => {
        setDeleteSuccess(false)
        setDeleteUserId(null)
        GetFeedbacksApi()
    }
    console.log('aactive',activeModuleId)

    const handleDeleteConfirmed = async (e) => {
     setIsLoading(true);
    setShowDeleteConfirmation(false);

    // console.log('caseid',caseid)
    try {
        const response = await tmdbApi.deleteEntireModuleFeedback(activeModuleId,activeCaseId);
        console.log('response',response)
        if (response?.result) {
            // Show success message
            setShowSuccessAlert(true);
              toast.success("Feedback deleted successfully");
            
            // Refresh the feedback list
            GetFeedbacksApi();
        } else {
            setShowErrorAlert(true);
              toast.error(response?.result || "Failed to delete feedback");
        }
    } catch (err) {
        console.error('Delete feedback error:', err);
        setShowErrorAlert(true);
        toast.error("An error occurred while deleting feedback");
    } finally {
        setActiveModuleId("")
        setActiveCaseId("")
        setIsLoading(false);
        setDeleteUserId(null);
    }
    }


    const handleViewUser = (e, paramuserid) => {
        GetTimeActivity()

        navigate("/viewcase/" + paramuserid);
    }

    const clearSearch = () => {
        GetTimeActivity()
        setUserSearch("");
        GetFeedbacksApi();
        setcurrentPage(1);
    }

    const customNoRecords = () => {
        return (

            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No data were found</p>
                </div> </div>
        )
    }
    // const handleExport = () => {

    //     // let k = defaultData || exportExcelData
    //     const modifiedArray = global.exportExcelData.map((each, i) => ({
    //         "S.NO": i + 1,
    //         "NAME": each?.name ?? "",
    //         "USER TYPE": each?.userType ?? "",
    //         "EMAIL ID": typeof each?.emailid === "object" && each?.emailid !== null && each?.emailid.length > 1 ? each?.emailid.join(', ') : each?.emailid ?? "",
    //         "PHONE NUMBER": each?.phone ?? "",
    //         "STATUS": each?.status ?? "",

    //     }));

    //     exportToExcel(modifiedArray, "data");

    // }
    // function exportToExcel(jsonData, fileName) {
    //     delete jsonData['_id'];
    //     const worksheet = XLSX.utils.json_to_sheet(jsonData);
    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    //     const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    //     const data1 = new Blob([excelBuffer], { type: 'application/octet-stream' });
    //     //FileSaver.saveAs(data, `${fileName}.xlsx`);
    //     FileSaver.saveAs(data1, `UsersData.xlsx`);
    //     console.log('data22222--->', data)
    // }
    const customSort = (rows, selector, direction) => {
        const sortedData = rows.slice().sort((rowA, rowB) => {
            // use the selector function to resolve your field names by passing the sort comparators
            // const aField = selector(rowA);
            const aField = String(selector(rowA)).toLowerCase();

            //  const bField = selector(rowB);
            const bField = String(selector(rowB)).toLowerCase();

            let comparison = 0;

            if (aField > bField) {
                comparison = 1;
            } else if (aField < bField) {
                comparison = -1;
            }

            return direction === 'desc' ? comparison * -1 : comparison;
        });

        // Log the sorted data to the console
        // setSortedRecomData(sortedData)
        global.exportExcelData = sortedData
        // console.log('Sorted Data------>:', sortedData);

        return sortedData;
    };
    // console.log("showSessionPopupup",showSessionPopupup)
    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper" className="create-case-db">
                <Header />
                <SideMenu />

                {/* Start right Content here  */}

                <div className="main-content user-management feedback-table" id="main-content">
                    <div className="page-content create-case-content" id="page-content">
                        <div className="container-fluid" id="container-fluid">

                            <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title" id="breadcrumb-title">Feedbacks</h4>
                                        </div>

                                        {/* <div>

                                            <button className="btn btn-primarys create-quiz-btn" onClick={handleAddUser}

                                                disabled={isRestricted} id="add-user-btn">
                                                CREATE CASE
                                            </button>
                                        </div> */}


                                    </div>
                                </div>
                            </div>

                            <div className="row table-data" id="table-data-row">
                                <div className="col-12">
                                    <div className="card" id="card">
                                        <div className="card-body" id="card-body">
                                            {isLoading ? <Loader /> : <>
                                                <div className="row mb-2" id="table-header-row">
                                                    <div className="col-sm-4 button-block" id="button-block">
                                                        <div className="dataTables_length" id="datatable-length">



                                                        </div>
                                                    </div>
                                                    <div className="col-sm-8">
                                                        <div className="search-box mb-2 d-inline-block" id="search-box">
                                                            <div className="position-relative">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={usersearch}
                                                                    onChange={(e) => handleChange(e)}
                                                                    placeholder="Search by module name"
                                                                    onKeyPress={handleKeypress}
                                                                    id="search-input"
                                                                />
                                                                <button
                                                                    className="fill_btn"
                                                                    onClick={(e) => handleSearch(e, "normalsearch")}
                                                                    id="search-btn">
                                                                    <span className="material-icons search-icon">search</span>
                                                                </button>
                                                            </div>
                                                            <div className="dataTables_length" id="datatable-length-reset">
                                                                <button
                                                                    className="fill_btn"
                                                                    onClick={clearSearch}
                                                                    id="reset-btn">
                                                                    <span className="material-icons-outlined">sync</span>Reset
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="text-sm-end" id="text-end"></div>
                                                    </div>
                                                </div>

                                                <DataTable
                                                    key={keyForRerender}
                                                    columns={columns}
                                                    keyField='_id'
                                                    data={data}
                                                    direction="auto"
                                                    highlightOnHover
                                                    fixedHeaderScrollHeight="300px"
                                                    pagination
                                                    responsive
                                                    persistTableHead
                                                    striped
                                                    subHeaderAlign="right"
                                                    defaultSortField="name"
                                                    noDataComponent={customNoRecords()}
                                                    paginationTotalRows={data?.length}
                                                    onChangeRowsPerPage={handlePerRowsChange}
                                                    onChangePage={handlePageChange}
                                                    paginationPerPage={rowsPerPage}
                                                    paginationDefaultPage={currentPageNew}
                                                    paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                                                    sortFunction={customSort}
                                                    paginationComponentOptions={{
                                                        rowsPerPageText: 'Per page:',
                                                        rangeSeparatorText: 'of',
                                                        noRowsPerPage: false,
                                                        selectAllRowsItem: false,
                                                        selectAllRowsItemText: 'All',
                                                    }}
                                                    // progressPending={isLoading}
                                                    // progressComponent={<Loader />}
                                                    id="data-table"
                                                />

                                            </>}

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <SweetAlert
                        show={tableErrMsg}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Something went wrong. Please reload again."}
                        onConfirm={e => setTableErrMsg(false)}
                        id="error-alert"
                    ></SweetAlert>
<SweetAlert
    show={showDeleteConfirmation}
    warning
    showCancel
    confirmBtnText="Yes"
    cancelBtnText="Cancel"
    confirmBtnBsStyle="danger"
    cancelBtnBsStyle="default"
    title="Are you sure you want to delete this feedback?"
    focusCancelBtn
    onConfirm={handleDeleteConfirmed}
    onCancel={handleDeleteCancelled}
/>

                    {/* <SweetAlert
                        show={deleteShow}
                        warning
                        showCancel
                        confirmBtnText="Yes"
                        cancelBtnText="Cancel"
                        confirmBtnBsStyle="danger"
                        cancelBtnBsStyle="default"
                        title="Are you sure you want to delete?"
                        focusCancelBtn
                        onConfirm={e => handleDelete(e)}
                        onCancel={e => onDeleteCancel(e)}
                    >
                    </SweetAlert> */}

                    <SweetAlert show={deleteSuccess}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Deleted Successfully"}
                        onConfirm={e => onDeletePopupClose(e)}
                    >
                    </SweetAlert>
       <ToastContainer
                id="toastContainer"
                position="bottom-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />

                    <Footer id="footer" />
                </div>





            </div>
            <style>
                {`
                    .user-management .rdt_Table .rdt_TableHeadRow .rdt_TableCol:nth-child(2), .user-management .rdt_Table .rdt_TableBody .rdt_TableRow
                    .rdt_TableCell:nth-child(2) {
                            min-width: 17% !important;
                        },
                        .user-management .rdt_Table .rdt_TableBody .rdt_TableRow .rdt_TableCell div:first-child {text-align: start;}
                    `}
            </style>
        </>
    );
};

export default Feedbacks;
